import styled from 'styled-components';

// export const ModalFormContainer = styled.div`
 
//   padding: 32px;
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   height: auto;
//   position: relative;
// `;

export const RowContainer = styled.form`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center; // Centers content vertically
`;

export const PasswordContainer = styled.div`
  position: relative;
  width: 100%;
`;


export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 10px;
  width: 40%;
`;


// export const ModalContainer = styled.div`
//   background-color: white;

//   width: 400px;
//   padding: 24px;
// `;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
`;

export const StyledInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const StyledSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;

  &:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${StyledInput}:checked + & {
    background-color: #4c53af;
  }

  ${StyledInput}:checked + &:before {
    transform: translateX(20px);
  }
`;
export const Bordas = styled.div`
  padding: 30px;
  background-color: white;
 
`;

